import { injectable } from 'inversify'

import type { IRequestHandler, IRequestSender } from './Plugins'

@injectable()
export class BaseApiGateWayPlugins {
  public senders: IRequestSender[]
  public handlers: IRequestHandler[]

  constructor() // Плагины для обработки ответа
  {
    // Список плагинов в порядке вызова
    this.senders = []
    this.handlers = []
  }

  registerHandler(handler: IRequestHandler) {
    this.handlers.push(handler)
  }

  registerSender(sender: IRequestSender) {
    this.senders.push(sender)
  }
}
